<!-- Loading template -->
<ng-template #loadingTemplate>
  <div class="container py-5 text-center">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
    <p class="mt-3">{{ 'LOADING_CONTENT' | translate }}</p>
  </div>
</ng-template>

<!-- Error template -->
<ng-template #errorTemplate>
  <div class="container py-5 text-center">
    <div class="alert alert-danger">
      <h4>{{ 'ERROR' | translate }}</h4>
      <p>{{ error }}</p>
    </div>
  </div>
</ng-template>

<app-page-header></app-page-header>
@if (journal && !isLoading) {
  <app-style-view [mainColor]="journal?.mainColor || '#00733f'"></app-style-view>
}

<!-- Main Content -->
@if (!isLoading && !error && items && items.length > 0) {
  <div class="container py-2"
    >
    <div class="row">
      <!-- Main Content Area -->
      <div class="col-md-12 pr-0">
        <!-- About Content Card -->
        <div class="card border-radius-0 bg-white border-0 box-shadow-2 mb-4">
          <div class="card-body">
            <!-- Tabs and Content -->
            <div class="row">
              <!-- Vertical Navigation Tabs -->
              <div class="col-md-3">
                <div class="tabs tabs-vertical tabs-right tabs-navigation tabs-navigation-simple">
                  <ul class="nav nav-tabs col-sm-3">
                    @for (group of items; track group; let i = $index) {
                      <li class="nav-item"
                        [class.active]="isGroupActive(group.slug)">
                        <a class="nav-link from-journal"
                          [class.active]="isGroupActive(group.slug)"
                          href="javascript:void(0)"
                          (click)="navigateToGroup(group.slug, i)">
                          {{ getTranslatedText(group.title) }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
              <!-- Content for Selected Group -->
              <div class="col-md-9 pl-0">
                @for (group of items; track group; let i = $index) {
                  <div
                    [class]="'tab-pane tab-pane-navigation ' + (isGroupActive(group.slug) ? 'active' : '')"
                    [id]="'cmsTab_' + i">
                    @if (isGroupActive(group.slug)) {
                      <div class="accordion accordion-lg" [id]="'accordion_' + i"
                        >
                        @for (item of group.items; track item; let j = $index) {
                          <div class="card card-default mb-3"
                            >
                            <!-- Accordion Header -->
                            <div class="card-header">
                              <h4 class="card-title m-0 pl-1">
                                <a class="accordion-toggle from-journal"
                                  href="javascript:void(0)"
                                  (click)="setAccordionState(i, j)">
                                  @if (group.items.length > 1) {
                                    <i class="fas fa-bars"></i>
                                  }
                                  {{ getTranslatedText(item.header || item.title, group.slug === 'boards') }}
                                </a>
                              </h4>
                            </div>
                            <!-- Accordion Content -->
                            <div [class]="'collapse ' + (isAccordionItemActive(i, j) ? 'show' : '')">
                              <div class="card-body">
                                <!-- Regular Content -->
                                @if (item.content) {
                                  <div
                                    class="from-journal-content text-justify"
                                    [innerHTML]="formatContent(item.content)">
                                  </div>
                                }
                                <!-- Special Board Content -->
                                @if (group.slug === 'boards' && item.titles) {
                                  <div>
                                    @for (boardTitle of item.titles; track boardTitle) {
                                      <div>
                                        <dl>
                                          <dt class="mb-2"> {{ getTranslatedText(boardTitle.title) }}
                                          </dt>
                                          <dd>
                                            @for (editor of boardTitle.editors; track editor) {
                                              <div class="mb-3">
                                                <app-author-view [author]="editor" [display]="'inline'"></app-author-view>
                                              </div>
                                            }
                                          </dd>
                                        </dl>
                                        <hr class="my-2" />
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="isLoading ? loadingTemplate : errorTemplate"></ng-template>
}